import { ContentApiContentDeleteRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useContentDeleteMutation = () =>
  useBaseMutation({
    mutationFn: (req: ContentApiContentDeleteRequest, config) =>
      appApiClient.contentApi.contentDelete(req, config),
  });
